import {useEffect, useState} from "react";
import {Select} from "antd";

export default function TileSelect ({value, onChange, tiles}) {
    const [tile, setTile] = useState(value)

    useEffect(() => {
        onChange && onChange(tile)
    }, [tile])

    return (
        <Select
            style={{width: 200}}
            size={'small'}
            suffixIcon={(<b>Tile</b>)}
            value={tile?.tile}
            onChange={(val) => {
                const _tile = tiles?.find(x => x.tile === val)
                setTile(_tile)
            }}
        >
            {tiles?.map(tile => (
                <Select.Option value={tile.tile} key={tile.tile}>
                    {tile.tile}
                </Select.Option>
            ))}
        </Select>
    )
}